import Service from "./Service";
const baseurl = '/api/historia-opcion-antecedente';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showByAc(id) {
        return Service.get(`${baseurl}/show-by-ac/${id}`);
    },
}